import { format, formatInTimeZone } from 'date-fns-tz';
import { isValid as isValidDate, parse, parseISO } from 'date-fns';
import { DEFAULT_INPUT_DATE_FORMAT, TIME_ZONES_ABBREVIATIONS, ISO_8601_FULL_FORMAT } from './OcrConstants';
export const getCurrentLocalDateAsUtcIso = () => {
    const currentLocalDateIsoDateOnly = format(new Date(), DEFAULT_INPUT_DATE_FORMAT);
    return new Date(currentLocalDateIsoDateOnly).toISOString();
};
export const findTimeZoneAbbreviationInDateString = (dateString) => TIME_ZONES_ABBREVIATIONS.find(tz => dateString.includes(tz)) || '';
export const convertDateStringToIso = (dateString) => {
    const originalDateInCurrentLocalTz = new Date(dateString);
    if (!isValidDate(originalDateInCurrentLocalTz))
        return '';
    const year = originalDateInCurrentLocalTz.getFullYear();
    const month = originalDateInCurrentLocalTz.getMonth();
    const day = originalDateInCurrentLocalTz.getDate();
    const utcDate = new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
    return utcDate.toISOString();
};
export const parseDateToIsoString = (dateString) => {
    try {
        const parsedIso8601WithTime = parse(dateString, ISO_8601_FULL_FORMAT, new Date());
        if (isValidDate(parsedIso8601WithTime)) {
            return dateString;
        }
        // handle formats 'yyyy', 'yyyy-MM-dd' (e.g. '2023', '2023-05-17').
        // these examples are still considered to be valid ISO according to `isValidDate(parseIso(dateString))`
        // new Date('2023').toISOString() -> '2023-01-01T00:00:00.000Z'
        // new Date('2023-05-17').toISOString() -> '2023-05-17T00:00:00.000Z'
        const parsedIso8601WitoutTime = parseISO(dateString);
        if (isValidDate(parsedIso8601WitoutTime)) {
            return new Date(dateString).toISOString();
        }
        const timeZone = findTimeZoneAbbreviationInDateString(dateString);
        if (timeZone) {
            const dateStringWithoutTimeZone = dateString.split(timeZone)[0];
            return convertDateStringToIso(dateStringWithoutTimeZone);
        }
        return convertDateStringToIso(dateString);
    }
    catch (e) {
        return '';
    }
};
export const formatDate = (date, dateFormat = DEFAULT_INPUT_DATE_FORMAT) => {
    if (!date)
        return '';
    if (typeof date === 'string') {
        const isoDateString = parseDateToIsoString(date);
        if (!isoDateString)
            return '';
        return formatInTimeZone(isoDateString, 'UTC', dateFormat);
    }
    if (typeof date === 'object' && date instanceof Date && isValidDate(date)) {
        return format(date, dateFormat, { timeZone: 'UTC' });
    }
    return '';
};
//# sourceMappingURL=DateUtils.js.map